// plant control center
import React from "react";

export default function PlantHUD({ onOpenLeaves, onCloseLeaves }) {
  return (
    <div className="leaf-btn">
      <button className="leaf-control-btn open" onClick={onOpenLeaves}>
        Open Leaves
      </button>

      <button className="leaf-control-btn close" onClick={onCloseLeaves}>
        Close Leaves
      </button>
    </div>
  );
}